var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_button__close",on:{"click":_vm.tapAction}},[_c('img',{staticClass:"c_img",attrs:{"src":require("../assets/img/buttons/close@3x.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }